(function(global) {
	'use strict';
	
	window.ISCL = window.ISCL || {};
	const ISCL = window.ISCL;
	
	ISCL.onLoaded = function(fns) {
        anchorScroll();
		const setFns = [
			improvementSource,
		];
		if (fns !== undefined && fns !== null) {
			for (let i = 0, len = fns.length; i < len; i++) {
				if (typeof fns[i] === 'function') {
					setFns.push(fns[i]);
				}
			}
		}
		addFnc(setFns);
	}
	ISCL.onResize = function(fn) {
		resized(function() {
			if (typeof as.startPos === 'function') as.onResize();
			if (typeof pd.pullData === 'function') pd.refresh();
			if (typeof fn === 'function') fn();
		});
	}
	
	/**
	 * Lighthouse Report 
	 -------------------------------------------------- */
	function improvementSource() {
		isrc.constructor();
	}
	const isrc = {
		constructor: function() {
			if (document.querySelector('a[target]:not([rel])') !== null) this.forBestPractices();
		},
		forBestPractices: function() {
			const blankLinks = document.querySelectorAll('a[target]:not([rel])');
			for (let i = blankLinks.length; i--;) {
				blankLinks[i].setAttribute('rel', 'noopener');
				
			}
		}
	}

  /**
	 * .js-navTrigger
	 -------------------------------------------------- */
	function drawerMenu() {
		if (document.querySelector('.js-navTrigger') !== null) {
			//console.log('-----> drawerMenu');
			dm.constructor();
		}
	}
	const dm = {
		constructor: function() {
			this.yOffset = window.pageYOffset;
			this.menu = document.getElementsByClassName('l-nav')[0];
			this.btn = document.getElementsByClassName('js-navTrigger');
			for (let i = this.btn.length; i--;) {
				this.btn[i].addEventListener('click', this.toggleMenu);
				this.btn[i].addEventListener('transitionend', this.btnEnd);
				this.btn[i].setAttribute('aria-label', 'メニューを開く');
				if (!ISCL.isDesktop) {
					this.btn[i].setAttribute('aria-expanded', false);
				}
			}
			if (!ISCL.isDesktop) {
				this.menu.setAttribute('aria-hidden', true);
			}
			this.menu.addEventListener('transitionend', this.menuEnd);
		},
		toggleMenu: function() {
			!dm.isOpened ? dm.openMenu() : dm.closeMenu();
		},
		openMenu: function() {
			dm.isOpened = true;
			dm.yOffset = window.pageYOffset;
			//console.log('openMenu', dm.yOffset);
			document.body.classList.add('is-fixed');
			document.body.style.marginTop = -dm.yOffset + 'px';
			
			dm.menu.classList.add('is-anim');
			dm.menu.classList.add('is-active');
			if (!ISCL.isDesktop) {
				dm.menu.setAttribute('aria-hidden', false);
			}
			for (let i = dm.btn.length; i--;) {
				dm.btn[i].classList.add('is-anim');
				dm.btn[i].classList.add('is-active');
				dm.btn[i].setAttribute('aria-label', 'メニューを開く');
				if (!ISCL.isDesktop) {
					dm.btn[i].setAttribute('aria-expanded', true);
				}
			}
		},
		closeMenu: function() {
			//console.log('closeMenu', dm.yOffset);
			document.body.classList.remove('is-fixed');
			document.body.removeAttribute('style');
			window.scrollTo(0, dm.yOffset);
			dm.isOpened = false;
			
			dm.menu.classList.add('is-anim');
			dm.menu.classList.remove('is-active');
			if (!ISCL.isDesktop) {
				dm.menu.setAttribute('aria-hidden', true);
			}
			for (let i = 0, len = dm.btn.length; i < len; i++) {
				dm.btn[i].classList.add('is-anim');
				dm.btn[i].classList.remove('is-active');
				dm.btn[i].setAttribute('aria-label', 'メニューを閉じる');
				if (!ISCL.isDesktop) {
					dm.btn[i].setAttribute('aria-expanded', false);
				}
			}
		},
		btnEnd: function(e) {
			if (e.propertyName === 'opacity') {
				this.classList.remove('is-anim');
			}
		},
		menuEnd: function(e) {
			if (e.propertyName === 'opacity' && e.target.nextElementSibling === null) {
				this.classList.remove('is-anim');
			}
		}
	};
  drawerMenu();

  
   /**
	 * .anc[href^="#"] アンカーリンク
	 -------------------------------------------------- */
	function anchorScroll() {
		if (document.querySelector('.anc') !== null || document.querySelector('.js-anc') !== null || location.hash) {
			//console.log('-----> anchorScroll');
			as.constructor();
		}
	}
	const as = {
		constructor: function() {
			if (location.hash) {
				window.scrollTo(0,0);
				setTimeout(this.landingScroll, 60);
              
			}
			
			this.SPF = 1000 / 60;
			this.duration = 800;
			this.scPad = 0;
			this.hash = null;
			this.onResize();
			this.cancelScroll(this);
			
			const anchor = document.querySelectorAll('.anc[href^="#"], .js-anc[href^="#"]');
			for (let i = 0, len = anchor.length; i < len; i++) {
				anchor[i].addEventListener('click', this.onClick);
			}
		},
		landingScroll: function() {
			//window.scrollTo(0,0);
			as.toScroll(location.hash.slice(1));
		},
		onClick: function(e) {
			e.preventDefault();
			const targetId = this.closest('[href]').getAttribute('href');
			as.toScroll(targetId.slice(1));
		},
		onResize: function() {
			this.scBtm = document.body.offsetHeight - window.innerHeight;
			this.scMax = document.body.clientHeight - window.innerHeight;
			if (document.querySelector('.l-header') !== null) {
				this.scPad = document.getElementsByClassName('l-header')[0].clientHeight - 1;
			}
		},
		toScroll: function(targetId) {
			if (targetId !== 'top' && document.getElementById(targetId) === null) return;
			//history.replaceState(null, null, './#' + targetId);
			
			if (dm.isOpened) dm.closeMenu();
			
			this.startPos = window.pageYOffset;
			this.currentPos = this.startPos;
			this.elapsedTime = 0;
			this.goalPos = (targetId !== 'top') ? (document.getElementById(targetId).getBoundingClientRect().top + window.pageYOffset - this.scPad) : 0;
			
			if (this.goalPos >= this.scMax) this.goalPos = this.scMax;
			
			this.valueInChange = this.goalPos - this.startPos;
			this.doScroll();
			this.hash = '#' + targetId;
		},
		doScroll: function() {
			/* MEMO: history.replaceState */
			if (as.hash !== '#top') {
				if (location.hash !== as.hash && as.hash !== null) location.hash = as.hash;
				//if (location.hash !== as.hash && as.hash !== null) {
				//	history.replaceState(null, null, './' + as.hash)
				//}
			} else {
				if (as.hash !== null) location.hash = '';
				//history.replaceState(null, null, './');
			}
			
			const elapsedTimeRate = as.elapsedTime / as.duration;
			const valueChangeRate = as.easing(elapsedTimeRate);
			const changeYOffset = as.valueInChange * valueChangeRate;
			
			as.currentPos = as.startPos + changeYOffset;
			
			if (as.elapsedTime >= as.duration) {
				as.currentPos = as.goalPos;
				clearTimeout(as.timer);
				return;
			} else {
				as.elapsedTime += as.SPF;
				as.timer = setTimeout(as.doScroll, as.SPF);
			}
			window.scrollTo(0, as.currentPos);
		},
		cancelScroll: function(t) {
			let count = 0;
			if (ISCL.isTouch) {
				window.addEventListener('touchmove', function() {
					clearTimeout(t.timer);
				});
			} else {
				this.wheel = function() {
					clearTimeout(t.timer);
				}
				if (window.addEventListener) { window.addEventListener('DOMMouseScroll', this.wheel, false); }
				window.onmousewheel = document.onmousewheel = this.wheel;
			}
		},
		/* easeOutQuart ( https://easings.net/ ) */
		easing: function(x) {
			return 1 - Math.pow(1 - x, 4);
		}
	};

	
	/**
	 * Pulldown UI 
	 * <button class="js-pullToggle" data-pull="{ID}">
	 * <div class="js-pullContents" data-pull="{ID}">
	 -------------------------------------------------- */
	function pulldownUi() {
		if (document.querySelector('.js-pullContents') !== null) {
			pd.constructor();
			ISCL.pd = pd;
		}
	}
	ISCL.pulldownUi = pulldownUi;
	const pd = {
		constructor: function() {
			//console.log('-----> pulldownUi');
			this.pullData = {};
			const toggle = document.getElementsByClassName('js-pullToggle');
			
			let property, contents;
			for (let i = 0, len = toggle.length; i < len; i++) {
				property = toggle[i].dataset['pull'];
				contents = document.querySelector('.js-pullContents[data-pull="' + property + '"]');
				
				contents.id = property;
				contents.setAttribute('aria-hidden', true);
				toggle[i].setAttribute('aria-expanded', false);
				toggle[i].setAttribute('aria-controls', property);
				
				if (this.pullData[property] === undefined) {
					this.pullData[property] = {
						isOpened: false,
						toggle: [],
						contents: contents,
						contentsHeight: contents.clientHeight
					};
					this.pullData[property].toggle.push(toggle[i]);
					contents.style.height = 0;
				} else {
					this.pullData[property].toggle.push(toggle[i]);
				}
				
				toggle[i].addEventListener('click', this.onClick);
			}
			//console.log(this.pullData);
		},
		refresh: function() {
			//console.log('-----> pd.refresh', this.pullData);
			for (let i in this.pullData) {
				if (this.pullData[i].isOpened) {
					this.pullData[i].contentsHeight = this.pullData[i].contents.clientHeight;
				} else {
					this.pullData[i].contents.removeAttribute('style');
					this.pullData[i].contentsHeight = this.pullData[i].contents.clientHeight;
					this.pullData[i].contents.style.height = 0;
				}
			}
		},
		onClick: function() {
			const property = this.dataset['pull'];
			const data = pd.pullData[property];
			!data.isOpened ? pd.pullOpen(data) : pd.pullClose(data);
			for (let i = data.toggle.length; i--;) {
				if (data.toggle[i].className.indexOf('-close') < 0) {
					data.toggle[i].classList.add('is-anim');
					data.toggle[i].classList.add('is-active');
					data.toggle[i].setAttribute('aria-expanded', true);
					data.toggle[i].addEventListener('transitionend', pd.toggleEnd);
				}
			}
		},
		pullOpen: function(data) {
			data.contents.classList.add('is-anim');
			data.contents.setAttribute('aria-hidden', false);
			data.contents.addEventListener('transitionend', pd.openEnd);
			data.contents.style.height = data.contentsHeight + 'px';
		},
		toggleEnd: function(e) {
			if (e.target !== this) {
				this.classList.remove('is-anim');
				this.removeEventListener('transitionend', pd.toggleEnd);
			}
		},
		openEnd: function(e) {
			if (e.propertyName === 'height') {
				pd.pullData[ this.dataset['pull'] ].isOpened = true;
				this.classList.add('is-active');
				this.classList.remove('is-anim');
				this.removeAttribute('style');
				this.removeEventListener('transitionend', pd.openEnd);
			
				// as.onResize
				if (this.querySelector('.js-anc') !== null) as.onResize();
			}
		},
		pullClose: function(data) {
			data.contents.style.height = data.contentsHeight + 'px';
			setTimeout(function() {
				data.isOpened = false;
				data.contents.classList.add('is-anim');
				data.contents.classList.remove('is-active');
				data.contents.setAttribute('aria-hidden', true);
				for (let i = data.toggle.length; i--;) {
					data.toggle[i].classList.remove('is-active');
					data.toggle[i].setAttribute('aria-expanded', false);
				}
				data.contents.style.height = 0;
				data.contents.addEventListener('transitionend', pd.closeEnd);
			}, 60);
		},
		closeEnd: function(e) {
			if (e.propertyName === 'height') {
				this.classList.remove('is-anim');
				this.removeEventListener('transitionend', pd.closeEnd);
			}
		}
	};
	
	/**
	 * in-view
	 * -------------------------------------------------- */
	function setInview() {
		//console.log('-----> setInview');
		iv.constructor();
	}
	const iv = {
		constructor: function() {
			if (document.querySelector('.js-inview') !== null) iv.basic();
			if (document.querySelector('img[data-src]') !== null) {
				iv.lazySetup();
			} else {
				pulldownUi();
			}
			inView.offset({ top: 80, right: 0, bottom: 80, left: 0 });
		},
		basic: function() {
			inView('.js-inview').on('enter', this.doInview);
		},
		doInview: function(el) {
			if (!el.isInview) {
				el.isInview = 1;
				el.classList.add('is-anim');
				el.classList.add('is-inview');
				el.addEventListener('transitionend', iv.animEnd);
			}
		},
		animEnd: function() {
			this.classList.remove('is-anim');
			this.classList.remove('js-inview');
			this.removeEventListener('transitionend', iv.animEnd);
		},
		// lazyLoader & inview
		lazySetup: function() {
			let cls, w, h;
			const imgs = document.querySelectorAll('img[data-src]');
			for (let i = 0, len = imgs.length; i < len; i++) {
				cls = imgs[i].getAttribute('class') ? ' ' + imgs[i].getAttribute('class') : '';
				w = imgs[i].getAttribute('width');
				h = imgs[i].getAttribute('height');
				imgs[i].src = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 ' + w + ' ' + h + '%22%3E%3C/svg%3E';
			}
			this.lazy();
			pulldownUi();
		},
		lazy: function() {
			inView('img[data-src]').on('enter', this.doLazy);
		},
		doLazy: function(el) {
			if (!el.isInview) {
				imagesLoaded(el, iv.imageLoaded);
				el.src = el.dataset['src'];
				el.isInview = 1;
			}
		},
		imageLoaded: function() {
			this.elements[0].classList.add('is-anim');
			this.elements[0].classList.add('is-loaded');
			this.elements[0].addEventListener('transitionend', iv.loadedEnd);
		},
		loadedEnd: function() {
			this.classList.remove('is-anim');
			this.removeAttribute('data-src');
			this.removeEventListener('transitionend', iv.loadedEnd);
		}
	};
   setInview();

	
	/**
	 * fetch 縺御ｽｿ縺医◆繧� fetch縲∽ｽｿ縺医↑縺九▲縺溘ｉ xhr 縺ｧ Ajax 縺吶ｋ
	 * (ISCL.)doAjax(request, function() {}, 'text');
	 * fetchAjax(request, function() {}, 'json');
	 * xhrAjax(request, function() {}, 'blob');
	 * -------------------------------------------------- */
	function doAjax(req, fn, format) {
		if (self.fetch) {
			fetchAjax(req, fn, format)
		} else {
			xhrAjax(req, fn, format)
		}
	}
	ISCL.doAjax = doAjax;
	function fetchAjax(req, fn, format) {
		//console.log('-----> fetchAjax');
		fetch(req)
		.then(function(response) {
			return new Promise(function(resolve, reject) {
				return response[format]()
				.then(function(data) {
					return resolve(data);
				}, function(error) {
					return reject(error);
				});
			});
		})
		.then(function(data) {
			//console.log('Success:', JSON.stringify(data))
			fn(data);
		}, function(error) {
			console.log('error ----->'.concat(error));
		});
	};
	function xhrAjax(req, fn, format) {
		//console.log('-----> xhrAjax');
		const xhr = new XMLHttpRequest();
		if (format !== 'json') {
			xhr.responseType = format;
		}
		xhr.addEventListener('progress', function(e) {
			const rate = e.loaded / (e.total == 0 ? e.loaded : e.total);
			//console.log(e, rate);
		});
		xhr.addEventListener('load', function(e) {
			if (xhr.readyState === 4) {
				if (xhr.status == 200 || xhr.status == 304) {
					let data = e.target.response;
					if (format === 'json') data = JSON.parse(data);
					fn(data);
				}
			}
		});
		xhr.open('GET', req);
		xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
		xhr.send();
	};
	
	/**
	 * common
	 * -------------------------------------------------- */
	const resized = function(fn) {
		if (resized.timer !== false) clearTimeout(resized.timer);
		resized.timer = setTimeout(fn, 200);
	};
	function breakPointLintener() {
		const breakPoint = window.matchMedia('(min-width: 768px)');
		breakPoint.addListener(function(e) { ISCL.isDesktop = e.matches; });
	}
	breakPointLintener();
	function addFnc(fns) {
		for (let i = 0, len = fns.length; i < len; i++) {
			if (typeof fns[i] === 'function') fns[i]();
		}
	}
	ISCL.addFnc = addFnc;
	(function common() {
		const doc = document.documentElement, ua = navigator.userAgent.toLowerCase();
		ISCL.isIE = ( ua.indexOf('msie') != -1 || ua.indexOf('trident') != -1 );
		ISCL.isTouch = !!( 'ontouchstart' in window || (navigator.pointerEnabled && navigator.maxTouchPoints > 0) );
		ISCL.isDesktop = window.matchMedia('(min-width: 768px)').matches;
		ISCL.isWindows = ua.indexOf('windows nt') !== -1;
		if (ISCL.isWindows) doc.classList.add('isWindows');
		if (ISCL.isTouch) doc.classList.add('isTouch');
		if (ISCL.isIE) doc.classList.add('isIE');
		if (window.innerWidth !== doc.clientWidth) doc.classList.add('hasScrollbar');
	})();
	
	// Element.closest() Polyfill
	Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector),Element.prototype.closest||(Element.prototype.closest=function(e){var t=this;do{if(Element.prototype.matches.call(t,e))return t;t=t.parentElement||t.parentNode}while(null!==t&&1===t.nodeType);return null});
})((this || 0).self || global);